import React from 'react';
import { Col, Row, Spinner } from 'reactstrap';
import { connect } from 'react-redux'

import { IoMdCheckmark } from 'react-icons/io'
import {
  FaFileWord,
  FaFileExcel,
  FaFileImage,
  FaFileVideo,
  FaFolder,
  FaFile,
  FaFileAudio,
  FaFilePdf,
  FaFilePowerpoint,
  FaFileArchive,
  FaFileCsv,
  FaEye,
  FaStar,
  FaRegStar
} from 'react-icons/fa';
import { Link } from "react-router-dom";
import { bindActionCreators } from "redux";
import queryString from "query-string";


import commonStyle from "commonStyle";

import { formatter } from "utils";

import extensions from 'constants/extensions'

import {
  STAR_OBJECT,
  STAR_OBJECT_FAILURE,
  STAR_OBJECT_SUCCESS,
  UNSTAR_OBJECT_SUCCESS,
  UNSTAR_OBJECT,
  UNSTAR_OBJECT_FAILURE,
} from 'constants/ActionTypes'

import { starObject, unstarObject } from "api/actions";

import './index.css';

class FileRow extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      hoveringOver: false,
      isStarred: props.isStarred,
      starLoading: false,
    };
  }

  componentWillReceiveProps(nextProps) {
    const nextState = {};

    switch (nextProps.type) {
      case STAR_OBJECT:
        if (this.props.id === nextProps.starredKey) {
          nextState.starLoading = true;
        }
        break;
      case UNSTAR_OBJECT:
        nextState.starLoading = true;
        break;
      case STAR_OBJECT_FAILURE:
        nextState.starLoading = false;
        break;
      case UNSTAR_OBJECT_FAILURE:
        nextState.starLoading = false;
        break;
      case STAR_OBJECT_SUCCESS:
        if (this.props.id === nextProps.starredKey) {
          nextState.isStarred = true;
        }
        nextState.starLoading = false;
        break;
      case UNSTAR_OBJECT_SUCCESS:
        if (this.props.id === nextProps.unstarredKey) {
          nextState.isStarred = false;
        }
        nextState.starLoading = false;
        break;
    }

    this.setState(nextState);
  }

  renderIcon = (key = '', isFolder) => {
    let component = null;
    let ext = key.split('.').pop();

    if (isFolder) {
      component = (
        <FaFolder />
      )
    } else if (this.isImage(ext)) {
      component = (
        <FaFileImage />
      )
    } else if (this.isVideo(ext)) {
      component = (
        <FaFileVideo />
      )
    } else if (this.isAudio(ext)) {
      component = (
        <FaFileAudio />
      )
    } else if (this.specialFile(ext)) {
      component = this.specialFile(ext);
    } else {
      component = (
        <FaFile />
      )
    }

    return (
      <h5 className={'fileRow-icon'}>{component}</h5>
    );

  };

  isImage = (ext = '') => {
    return extensions.image.includes(ext.toLowerCase())
  };

  isVideo = (ext) => {
    return extensions.video.includes(ext.toLowerCase())
  };

  isAudio = (ext) => {
    return extensions.audio.includes(ext.toLowerCase())
  };

  specialFile = (ext) =>  {
    const extensions = {
      'csv': <FaFileCsv/>,
      'docx': <FaFileWord/>,
      'doc': <FaFileWord/>,
      'xlsx': <FaFileExcel/>,
      'pdf': <FaFilePdf />,
      'pptx': <FaFilePowerpoint />,
      'zip': <FaFileArchive />,
      'gz': <FaFileArchive />
    };

    return extensions[ext.toLowerCase()];
  };

  onStar = (e) => {
    e.stopPropagation();
    if (!this.state.isStarred) {
      this.props.starObject({ id: this.props.id });
    } else {
      this.props.unstarObject({ id: this.props.id });
    }
  };

  renderItem = ({ item, path, isDir, isHovered, isPreviewable, onView }) => {
    const name = formatter.truncateText(item);

    const previewLink = isPreviewable ? '' : 'fileRow-title-no-preview '
    let component = (
      <p
        className={`${previewLink}fileRow-title file-row-text`}
        onClick={(e) => {
          if (onView) {
            e.stopPropagation();
            onView();
          }
        }}
      >
        {name}
      </p>
    );

    if (isDir) {
      component = (
        <Link
          className={`${previewLink}fileRow-title file-row-text`}
          to={`/dashboard?prefix=${path}`}
          replace
        >
          {name}
        </Link>
      );
    }

    return component;
  };

  render(){
    const {
      canPreview = true,
      canSelect,
      canStar = true,
      date_deleted : dateDeleted,
      hideLastModified,
      hideSize,
      hidePath = true,
      hideDateDeleted = true,
      is_dir: isDir,
      name: item,
      last_modified_timestamp: lastModified,
      onCheckbox,
      onSelect,
      onView,
      path,
      size,
    } = this.props;

    let { isSelected } = this.props;

    const { isStarred, starLoading } = this.state;

    const isHovered = this.state.hoveringOver;

    const ext = item.split('.').pop();

    const isPreviewable = canPreview;

    const showCheckbox = (isSelected || isHovered) && !isDir;

    isSelected = isSelected && !isDir;

    return (
      <tr
        className={'file-row'}
        onMouseOver={() => {
          this.setState({
            hoveringOver: true
          })
        }}
        onMouseLeave={() => {
          this.setState({
            hoveringOver: false
          })
        }}
        onClick={() => {
          if (onSelect && !isDir) {
            onSelect();
          }
        }}
      >
        {canSelect &&
        <td
          style={{
            width: 50,
          }}
        >
          {showCheckbox &&
          <div
            className={'checkbox'}
            onClick={(e) => {
              if (onCheckbox) {
                e.stopPropagation();
                onCheckbox();
              }
            }}
          >
            { isSelected && <h6 style={{}}><IoMdCheckmark /></h6> }
            <input type="checkbox" hidden={true} checked={isSelected}/>
          </div>
          }
        </td>
        }
        <td
          style={{
            backgroundColor: isSelected && commonStyle.title,
            marginRight: 10
          }}
        >
          <div
            className={'file-row-title-container'}
            onClick={e => e.stopPropagation()}
          >
            {this.renderIcon(item, isDir)}
            {this.renderItem({ item, path, isDir, isHovered, isPreviewable, onView })}
            {canStar &&
              <h5 style={{ width: 40 }} data-tooltip="star" onClick={this.onStar}>
                { isHovered && starLoading && <Spinner size={'sm'} />}
                { isHovered && !isStarred && !starLoading && <FaRegStar/> }
                { isHovered && isStarred && !starLoading && <FaStar/> }
              </h5>
            }
          </div>
          {
          !hidePath &&
          <p
            className='file-row-title-path'
          >
            {path}
          </p>
        }
        </td>
        {
          !hideLastModified &&
          <td
            className={'file-row-date'}
            style={{
              backgroundColor: isSelected && commonStyle.title,
              margin: 0,
              padding: 0
            }} 
          >
            {formatter.formatDate(lastModified)}
          </td>
        }
        {
          !hideDateDeleted &&
          <td
            className={'file-row-date'}
            style={{
              backgroundColor: isSelected && commonStyle.title,
              margin: 0,
              padding: 0
            }} 
          >
            {formatter.formatDateFromNow(dateDeleted)}
          </td>
        }
        {!hideSize &&
          <td
            style={{
              backgroundColor: isSelected && commonStyle.title 
            }}
          >
            <h6 className='file-row-text'>{formatter.memorySizeFormatter(size)}</h6>
          </td>
        }
      </tr>
    )
  }
};

FileRow.defaultProps = {
  isStarred: false,
  canSelect: true
};

const mapStateToProps = (state) => ({
  starredKey: state.starredKey,
  unstarredKey: state.unstarredKey,
  type: state.type,
});

const dispatchToProps = (dispatch) => {
  return bindActionCreators({ starObject, unstarObject }, dispatch)
};


export default connect(mapStateToProps, dispatchToProps)(FileRow);
